export type FileNode = File | Directory;

export type File = {
    type: "file";
    name: string;
    fileType: "text" | "link";
};

export type Directory = {
    type: "directory";
    name: string;
    children: FileNode[];
    parent?: Directory;
};

export async function loadFilesystem(): Promise<Directory> {
    const res = await fetch("/files-index.json");
    const raw = await res.json();
    return buildDirectory("files", raw, undefined);
}

function buildDirectory(name: string, obj: any, parent?: Directory): Directory {
    const children: FileNode[] = [];

    for (const [key, value] of Object.entries(obj)) {
        if (value === "file") {
            children.push({
                type: "file",
                name: key,
                fileType: key.endsWith(".pdf") ? "link" : "text"
            });
        } else {
            const dir = buildDirectory(key, value, undefined);
            dir.parent = undefined;
            children.push(dir);
        }
    }

    const dir: Directory = { type: "directory", name, children, parent };
    children.forEach(child => {
        if (child.type === "directory") child.parent = dir;
    });
    return dir;
}